import ClipboardIcon from "../icons/Clipboard";
import cn from "../../lib/classnames";
import logger from "../../lib/logger";
import React from "react";
import ShareIcon from "../icons/Share";
import styles from "./IconButton.module.css";

export enum IconType {
    Clipboard,
    Share,
}

type Props = {
    className?: string;
    label: string;
    iconType: IconType;
    onClick: () => void;
};

const IconButton = React.forwardRef<HTMLButtonElement, Props>(
    ({className, label, iconType, onClick}: Props, ref) => {
        function renderIcon() {
            switch (iconType) {
                case IconType.Clipboard:
                    return <ClipboardIcon className={styles.icon} />;
                case IconType.Share:
                    return <ShareIcon className={styles.icon} />;
                default:
                    logger.warn(`invalid icon button icon type: ${iconType}`);
                    return null;
            }
        }

        return (
            <button ref={ref} className={cn(styles.button, className)} onClick={onClick}>
                {renderIcon()}
                <div className={styles.label}>{label}</div>
            </button>
        );
    },
);

export default IconButton;
